/// <reference types="vite-plugin-svgr/client" />
import React from "react";

import { Button, Col, Container, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { getUrlLangPrefix } from "@/utils/Local";

import i18n from "../../i18n";

const PartnersScreen: React.FC = () => {
  const { t } = i18n;
  const langPrefix = getUrlLangPrefix();
  const items = [
    {
      icon: (
        <img
          alt={t("Dream Legacy Foundation")}
          className="mw-100"
          src="/images/partners/DreamLegacyFoundation.svg"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("Le Groupe BBC")}
          className="mw-100"
          src="/images/partners/Le_Groupe_BBC.jpg"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("Knights Bridge Development Corp")}
          className="mw-80"
          src="/images/partners/KnightsBridge.svg"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("Modulink Design Build")}
          className="mw-100"
          src="/images/partners/ModulinkDesignBuild.png"
        />
      ),
    },
    {
      icon: (
        <img alt={t("MCH")} className="mw-100" src="/images/partners/MCH.png" />
      ),
    },
    {
      icon: (
        <img
          alt={t("Canada NRC")}
          className="mw-100"
          src="/images/partners/NRC.png"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("Investissement Québec")}
          className="mw-100"
          src="/images/partners/Investissement_Quebec.png"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("Cycle Momentum")}
          className="mw-100"
          src="/images/partners/Cycle_Momentum.png"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("Centre For Housing Innovation by DMZ")}
          className="mw-100"
          src="/images/partners/CHL_DMZ.jpg"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("MaRS")}
          className="mw-100"
          src="/images/partners/MaRS.png"
        />
      ),
    },
  ];

  return (
    <Container fluid className="screenContainer mt-2 mb-2">
      <Container className="flexContainer">
        <Row className="w-100">
          <Col xs={12}>
            <h2 className="text-center text-lg-start">{t("Our Partners")}</h2>
          </Col>
        </Row>

        <div className="partnersGrid align-items-center mt-4 gap-5">
          {items.map((item, index) => (
            <div key={index} className="partnerContainer">
              {item.icon}
            </div>
          ))}
        </div>

        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center w-100 mt-5 gap-5 p-4 card partnershipContainer">
          <div>
            <img
              alt={t("The Steven Low Foundation - La Fondation Steven Low")}
              className="mw-100"
              src="/images/partners/SLF-logo.png"
            />
          </div>
          <div className="d-flex flex-column text-center text-lg-start gap-2">
            <h3>{t("Giving Back")}</h3>
            <p>
              {t(
                "At PakVille, we are committed to creating impact beyond construction. We proudly partner with The Steven Low Foundation, contributing to stronger, more resilient communities.",
              )}
            </p>
            <NavLink to={`${langPrefix}/${t("_route.partnerships")}`}>
              <Button className="btn-primary">{t("Learn More")}</Button>
            </NavLink>
          </div>
        </div>
      </Container>
    </Container>
  );
};

export default PartnersScreen;
